import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { InfoListItem } from '@brightlayer-ui/react-components';
import { DataIndicators } from '../DataIndicators';
import { ChartColors } from '../ReusableTrendsGraph/colors';

const convertUserList = (tableRowData: any): any => {
    const tableRowList: any = [];
    tableRowData.forEach((user: any) => {
        const obj = {
            statusColor:user.channelNumber,
            channelName: user.channelName,
            channelNumber: user.channelNumber,
            highPdi: user.pdData.highPdi ? user.pdData.highPdi : '',
            pdiAlarmPoint: user.pdData.pdiAlarmPoint ? user.pdData.pdiAlarmPoint : '',
            highQmax: user.pdData.highQmax ? user.pdData.highQmax : '',
            qmaxAlarmPoint: user.pdData.qmaxAlarmPoint ? user.pdData.qmaxAlarmPoint : '',
            highPps: user.pdData.highPps ? user.pdData.highPps : '',
            highPpc: user.pdData.highPpc ? user.pdData.highPpc : '',
        };
       tableRowList.push(obj);
    });

    return tableRowList;
};

export const SensorDetailData: React.FC<{ SensorTrendData?: any }> = (
    props
) => {
    const data: [] = props.SensorTrendData ? props.SensorTrendData : [];
    const formatedTableRowDataList = convertUserList(data);    
   
    return (
        <>
            <DataIndicators
                errorMessage="Record not found"
                emptyMessage="Record not found"
                data={props.SensorTrendData}
                emptyIcon="BarChart"
                isEmpty={false}
                isDetailedInfo={false}
            />

            {props.SensorTrendData && (
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table" data-testid="sensor-data">
                        <TableHead style={{ backgroundColor: '#F3F5F5' }}>
                            <TableRow>
                                <TableCell>Sensor Name</TableCell>
                                <TableCell align="right">High PDI</TableCell>
                                <TableCell align="right">PDI Alarm Point</TableCell>
                                <TableCell align="right">High QMax</TableCell>
                                <TableCell align="right">QMax Alarm Point</TableCell>
                                <TableCell align="right">High PPS</TableCell>
                                <TableCell align="right">High PPC</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {formatedTableRowDataList.map((row: any) => (
                                <TableRow
                                    key={row.channelNumber}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row" style={{ padding: '0px' }}>
                                        <InfoListItem
                                            style={{ height: 'auto' }}
                                            title={''}
                                            subtitle={''}
                                            divider={undefined}
                                            statusColor = {ChartColors[row.statusColor === 1 ? 0 : row.statusColor % ChartColors.length]}
                                            leftComponent={
                                                <span style={{ marginLeft: '-30px' }}>{row.channelName}</span>
                                            }
                                        ></InfoListItem>
                                    </TableCell>
                                    <TableCell align="center">{row.highPdi}</TableCell>
                                    <TableCell align="center">{row.pdiAlarmPoint}</TableCell>
                                    <TableCell align="center">{row.highQmax}</TableCell>
                                    <TableCell align="center">{row.qmaxAlarmPoint}</TableCell>
                                    <TableCell align="center">{row.highPps}</TableCell>
                                    <TableCell align="center">{row.highPpc}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    );
};
